import { apiUrlsList } from '../../../../config';
import {
  CartCollectedResponse,
  CartCollectedResponseError,
  CartProductIdsList,
  ProductItemId
} from '../../../../store/cart';
import { getRegionId } from '../../../../helpers/getRegion/getRegionId';
import {
  CartItemUpdateProps,
  CartItemUpdateRequestProps
} from '../../../../types/cart';
import { apiService } from '../../apiService';

export const requestCart = apiService.createGetMethod<
  // eslint-disable-next-line @typescript-eslint/ban-types
  {},
  CartCollectedResponse
>(apiUrlsList.getCart, {
  mapRequest: () => ({
    headers: {
      'region-id': getRegionId(),
      features: 'use_multiselect'
    }
  })
});

export const addCartItemRequest =
  apiService.createPostMethod<
    CartItemUpdateProps[],
    CartCollectedResponse | CartCollectedResponseError
  >(apiUrlsList.updateCart, {
    mapRequest: (body) => ({
      headers: {
        'region-id': getRegionId(),
        features: 'use_multiselect'
      },
      body: JSON.stringify({
        products: body.map(({ id, quantity }) => ({
          id,
          quantity
        }))
      })
    })
  });

export const requestCartItemsChange =
  apiService.createPatchMethod<
    CartItemUpdateRequestProps[],
    CartCollectedResponse | CartCollectedResponseError
  >(apiUrlsList.updateCart, {
    mapRequest: (productsList) => {
      return {
        headers: {
          'region-id': getRegionId(),
          features: 'use_multiselect'
        },
        body: JSON.stringify(
          productsList.reduce((data, props) => {
            const responseItem: Partial<{
              id: ProductItemId;
              quantity: number;
              delay: boolean;
            }> = {
              id: props.id
            };

            if ('newQuantity' in props) {
              responseItem.quantity = props.newQuantity;
            }

            if ('delay' in props) {
              responseItem.delay = props.delay;
            }

            data.push(responseItem);

            return data;
          }, [])
        )
      };
    }
  });

export const requestCartItemGroupRemove =
  apiService.createDeleteMethod<
    { id: CartProductIdsList },
    CartCollectedResponse | CartCollectedResponseError
  >(apiUrlsList.updateCart, {
    mapRequest: (body) => ({
      headers: {
        'region-id': getRegionId(),
        features: 'use_multiselect'
      },
      body: JSON.stringify(body)
    })
  });

export const requestClearCart = apiService.createPostMethod<
  // eslint-disable-next-line @typescript-eslint/ban-types
  {},
  [] | CartCollectedResponseError
>(apiUrlsList.clearCart, {
  mapRequest: () => ({
    headers: {
      'region-id': getRegionId(),
      features: 'use_multiselect'
    }
  })
});
